import { useState } from "react";
import { IconMessageCircle, IconMail } from "@tabler/icons-react";
import ModalShell from "./ModalShell";
import styles from "./SupportModal.module.css";
import Button from "../UI/Button/button";
import Input, { Select, Textarea } from "../UI/FormInput/input";
import { postSupportComplaint } from "../../services/clientCalls";
import { errorHandler } from "../../utils";

const TOPICS = [
  "Billing & subscription",
  "Account access",
  "Job posting",
  "Applicant management",
  "Platform features",
  "Partnership inquiry",
  "Other",
];

const EMPTY = {
  supportType: "Contact",
  fullName: "",
  email: "",
  subject: "",
  message: "",
};

export default function ContactModal({ open, onClose, setToast }) {
  const [form, setForm] = useState(EMPTY);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const set = (key) => (e) => setForm((f) => ({ ...f, [key]: e.target.value }));

  const handleClose = () => {
    setForm(EMPTY);
    onClose();
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    try {
      const payload = {
        supportType: "Contact",
        fullName: form.fullName,
        email: form.email,
        subject: form.subject,
        message: form.message,
      };
      const res = await postSupportComplaint(payload);
      if (res?.data?.success) {
        handleClose();
        setToast({
          visible: true,
          message: "Message sent! We'll reply to your email shortly.",
        });
      }
    } catch (error) {
      error?.response?.data
        ? errorHandler(error?.response?.data?.errors, "Error")
        : errorHandler(
            "Network error: Something went wrong, Please check your internet connection and try again.",
            "Error",
          );
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <ModalShell
      open={open}
      onClose={handleClose}
      icon={IconMessageCircle}
      color="blue"
      title="Contact Us"
      subtitle="We'll get back to you within 4–8 hours"
      footer={
        <>
          <Button variant="ghost" onClick={handleClose}>
            Cancel
          </Button>
          <Button
            variant="secondary"
            leftIcon={<IconMail size={14} />}
            onClick={handleSubmit}
            disabled={isSubmitting}
            loading={isSubmitting}
          >
            Send Message
          </Button>
        </>
      }
    >
      <div className={styles.row2}>
        <Input
          label="Your Name"
          required
          id="contact-name"
          placeholder="Full name"
          value={form.fullName}
          onChange={set("fullName")}
        />
        <Input
          label="Email"
          required
          id="contact-email"
          type="email"
          placeholder="you@company.com"
          value={form.email}
          onChange={set("email")}
        />
      </div>

      <Select
        label="Subject"
        required
        id="contact-subject"
        value={form.subject}
        onChange={set("subject")}
      >
        <option value="" disabled>
          Select a topic…
        </option>
        {TOPICS.map((t) => (
          <option key={t} value={t}>
            {t}
          </option>
        ))}
      </Select>

      <Textarea
        label="Message"
        required
        id="contact-message"
        placeholder="How can we help you? Please include as much detail as possible…"
        value={form.message}
        onChange={set("message")}
      />
    </ModalShell>
  );
}
